import { Tooltip } from 'radix-ui';

export function RibbonTooltip({
  name,
  children,
}: React.PropsWithChildren<{ name: string }>) {
  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          sideOffset={5}
          side="bottom"
          className="pointer-events-none! rounded border border-gray-200 bg-white px-3.75 py-2.5 text-[15px] leading-none shadow will-change-[transform,opacity]"
        >
          <span className="absolute top-0 left-1/2 h-2 w-2 -translate-x-1/2 -translate-y-1/2 rotate-45 border border-gray-200 border-r-transparent border-b-transparent bg-white"></span>
          {name}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
}
